import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  inject,
} from '@angular/core';

@Component({
  selector: 'app-select-all-header',
  templateUrl: './custom-select-all-header.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomSelectAllHeaderComponent
  implements IHeaderAngularComp, OnDestroy
{
  private changeDetectorRef = inject(ChangeDetectorRef);

  public params!: IHeaderParams;
  public isAllSelected = false;

  private selectionListener = this.updateCheckbox.bind(this);

  agInit(params: IHeaderParams): void {
    this.params = params;
    this.params.api.addEventListener('filterChanged', this.selectionListener);
    this.params?.api.addEventListener(
      'selectionChanged',
      this.selectionListener,
    );
    this.updateCheckbox();
  }

  public toggleSelect(): void {
    this.isAllSelected = !this.isAllSelected;

    this.params.api.forEachNodeAfterFilter((node) => {
      if (node.selectable) {
        node.setSelected(this.isAllSelected);
      }
    });
  }

  private updateCheckbox(): void {
    let total = 0;
    let selected = 0;
    this.params?.api?.forEachNodeAfterFilter((node) => {
      total++;
      if (node.isSelected()) {
        selected++;
      }
    });
    this.isAllSelected = total > 0 && selected === total;
    this.changeDetectorRef.markForCheck();
  }

  refresh(): boolean {
    return true;
  }

  ngOnDestroy(): void {
    this.params?.api.removeEventListener(
      'filterChanged',
      this.selectionListener,
    );
    this.params?.api.removeEventListener(
      'selectionChanged',
      this.selectionListener,
    );
  }
}
